import _ from "lodash";
import { toast } from "react-toastify";
import { default_guest_nationality } from "../../../actions/single_search/accommodation_search";
import { createTransferBooking, transferPreBook } from "../../../api/transfers";
import { transfersErrorMsgs } from "../../../errors";

export const flightsDtlsObj = {
  inbound: {},
  outbound: {},
  inboundFlightNumber: "",
  inboundAirlineName: "",
  outboundFlightNumber: "",
  outboundAirlineName: "",
};

export function getRequiredFields(tripMode) {
  switch (tripMode) {
    case "air_to_poi":
      return ["inbound", "inboundFlightNumber", "inboundAirlineName"];
    case "poi_to_air":
      return ["outbound", "outboundFlightNumber", "outboundAirlineName"];

    default:
      return [
        "inbound",
        "inboundFlightNumber",
        "inboundAirlineName",
        "outbound",
        "outboundFlightNumber",
        "outboundAirlineName",
      ];
  }
}

export async function onTransferPreBook({
  transfer,
  search_session_id,
  onCancel,
}) {
  var data = {
    session_id: search_session_id,
    supplier: transfer.supplier,
    booking_id: transfer.booking_id,
  };

  const result = await transferPreBook({ data });
  if (!result) {
    toast.warning(transfersErrorMsgs.detailView.no_availability, {
      duration: 3000,
    });
    onCancel();
    return null;
  }
  return result;
}

export async function onTransferBooking({
  market_type,
  website_meta,
  source_entity,
  session_id,
  transfer,
  preBookResult,
  flightsDtls,
  guests,
  tripMode,
  customer_user_data,
}) {
  var handling_info_Temp = {};
  var inbound = {};
  var outbound = {};

  if (tripMode === "air_to_poi") {
    inbound = {
      departing_airport: _.get(flightsDtls, "inbound.inbound_meta.0.value"),
      arriving_airport: transfer.origin.name,
      airline: flightsDtls.inboundAirlineName,
      flight_number: flightsDtls.inboundFlightNumber,
    };
  }

  if (tripMode === "poi_to_air") {
    outbound = {
      departing_airport: transfer.destination.name,
      arriving_airport: _.get(flightsDtls, "outbound.outbound_meta.0.value"),
      airline: flightsDtls.outboundAirlineName,
      flight_number: flightsDtls.outboundFlightNumber,
    };
  }

  handling_info_Temp = {
    inbound,
    outbound,
  };

  var transfer_type = _.get(transfer, "outbound.vehicle.vehicle_type");
  if (!transfer_type) {
    transfer_type = _.get(transfer, "inbound.vehicle.vehicle_type");
  }
  transfer_type = transfer_type === "private" ? "PR" : "SH";

  const convertedGuests = _.cloneDeep(guests);
  convertedGuests.forEach((g) => {
    g.guest_title = g.title;
    delete g.title;

    g.nationality = g.nationality ? g.nationality : default_guest_nationality;
  });

  var payload = {
    market_type,
    api_uid: transfer.api_uid,
    booking_id: preBookResult.booking_id,
    prebook_id: preBookResult.prebook_id,
    session_id,
    guests: convertedGuests,
    outbound_start: _.get(transfer, "outbound.start"),
    inbound_start: _.get(transfer, "inbound.start"),
    origin_type: tripMode !== "poi_to_air" ? "AIR" : "ACC",
    origin_name: transfer.origin.name,
    origin_id: "",
    origin_geodata: transfer.origin.geodata,
    destination_type: tripMode !== "poi_to_air" ? "ACC" : "AIR",
    destination_name: transfer.destination.name,
    destination_id: "",
    destination_geodata: transfer.destination.geodata,
    outbound_vehicle: _.get(transfer, "outbound.vehicle"),
    inbound_vehicle: _.get(transfer, "inbound.vehicle"),
    supplier: _.get(transfer, "supplier"),
    handling_info: handling_info_Temp,
    outbound_provider: _.get(transfer, "outbound.provider"),
    inbound_provider: _.get(transfer, "inbound.provider"),
    outbound_duration: _.get(transfer, "outbound.duration"),
    outbound_distance: _.get(transfer, "outbound.distance"),
    inbound_duration: _.get(transfer, "inbound.duration"),
    inbound_distance: _.get(transfer, "inbound.distance"),
    transfer_type,
    website_meta,
    source_entity,
    customer_user_data,
  };

  const bookingResult = await createTransferBooking({ payload });
  return bookingResult;
}
